import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const SuccessFilled: React.FunctionComponent<Props> = (props) => {
  const { size = 32, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      fill='none'
      stroke='currentColor'
      viewBox='0 0 32 32'>
      <path
        fill='#008071'
        stroke='#008071'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M16 28a12 12 0 1 0 0-24 12 12 0 0 0 0 24Z'
      />
      <path
        stroke='#fff'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='m20.67 12.67-6.42 6.66-2.92-3.03'
      />
    </svg>
  );
};

export default SuccessFilled;
